import { FunctionComponent } from 'react';

import arrowRight from 'theme/icons/arrow-right.svg';
import agreementIcon from 'theme/icons/bullet-1.svg';
import timeIcon from 'theme/icons/bullet-2.svg';
import locationIcon from 'theme/icons/bullet-3.svg';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutArticleNewestJobs: FunctionComponent<Props> = ({
    jobs,
    jobsCopy,
    iconsAlts,
}) => {
    if(!Array.isArray(jobs) || jobs.length === 0) {
        return null;
    }

    return (
        <StyledComponent>
            <h2 className="jobs-title">
                {jobsCopy.title}
            </h2>
            {jobs.map(job => (
                <div
                    className="job"
                    key={job.id}
                >
                    <p className="job-name">
                        {job.name}
                    </p>
                    <div className="job-info">
                        <p className="job-company">
                            {job.companyName}
                        </p>
                        <p className="job-agreement">
                            <img
                                src={agreementIcon}
                                alt={iconsAlts?.agreement}
                                className="job-img"
                                loading="lazy"
                            />
                            {Array.isArray(job.jobAgreements) && job.jobAgreements.map(agreement => agreement.name)}
                        </p>
                        <p className="job-time">
                            <img
                                src={timeIcon}
                                alt={iconsAlts?.time}
                                className="job-img"
                                loading="lazy"
                            />
                            {job.jobTime.name}
                        </p>
                        <p className="job-city">
                            <img
                                src={locationIcon}
                                alt={iconsAlts?.location}
                                className="job-img"
                                loading="lazy"
                            />
                            {job?.primaryCity?.name}
                        </p>
                        <img
                            src={arrowRight}
                            alt={iconsAlts?.arrow}
                            className="job-arrow"
                            loading="lazy"
                        />
                    </div>
                </div>
            ))}
        </StyledComponent>
    );
};

export default PublicLayoutArticleNewestJobs;